import { useContext } from "react";
import { ScheduleTaggingContext } from "../ScheduleTaggingProvider";

export function useScheduleTagging() {
  const tagging = useContext(ScheduleTaggingContext);
  if (!tagging) {
    throw new Error("useScheduleTagging must be used within ScheduleTaggingProvider.");
  }
  return tagging;
}
